function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.75 14.25V9.25C33.75 8.58696 33.4866 7.95107 33.0178 7.48223C32.5489 7.01339 31.913 6.75 31.25 6.75H13.75V4.25C13.75 3.58696 13.4866 2.95107 13.0178 2.48223C12.5489 2.01339 11.913 1.75 11.25 1.75H3.75C3.08696 1.75 2.45107 2.01339 1.98223 2.48223C1.51339 2.95107 1.25 3.58696 1.25 4.25V31.4167C1.25941 32.0974 1.51363 32.752 1.96614 33.2607C2.41865 33.7694 3.0392 34.0981 3.71423 34.1867C4.38926 34.2754 5.07363 34.118 5.64211 33.7433C6.2106 33.3687 6.62518 32.8019 6.81 32.1467L10.7283 16.0517C10.8797 15.5315 11.1958 15.0746 11.6293 14.7497C12.0627 14.4247 12.59 14.2494 13.1317 14.25H36.25C36.6332 14.2499 37.0113 14.3378 37.3551 14.5071C37.6989 14.6764 37.9992 14.9224 38.2328 15.2262C38.4664 15.53 38.627 15.8835 38.7022 16.2592C38.7774 16.635 38.7653 17.023 38.6667 17.3933L35 32.3933C34.8582 32.9259 34.5443 33.3967 34.1073 33.7325C33.6702 34.0682 33.1345 34.2502 32.5833 34.25H4.07833",
  stroke: "#1B75BB",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a2e8907b.svg";
export { ForwardRef as ReactComponent };